var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82178 8.08364L15.5996 8.08364M12.4884 11.6728H15.5996M8.044 15.2619H15.5996M4 7.81345L4 15.4403C4 17.9181 5.32318 19.2538 7.77778 19.2538H14.4748C16.0396 19.2538 16.1798 20.5291 17.3076 21.2122C18.4925 21.9299 20 21.0683 20 19.6734V7.81344C20 5.33567 18.6768 4 16.2222 4L7.77778 4C5.32318 4 4 5.33567 4 7.81345Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4b3e8db0da0458df9bd2b90bcd1faec9.svg";
export { ForwardRef as ReactComponent };